﻿package com.mgacreative.hotelru.feature.pricing.di

import com.mgacreative.hotelru.feature.pricing.ui.DynamicPricingViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getPricingFeatureModule() = module {
    viewModel { DynamicPricingViewModel(get(), get()) }
}

